import { render } from "./BulkEmail.vue?vue&type=template&id=0a29c3b3&scoped=true"
import script from "./BulkEmail.vue?vue&type=script&lang=js"
export * from "./BulkEmail.vue?vue&type=script&lang=js"

import "./BulkEmail.vue?vue&type=style&index=0&id=0a29c3b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a29c3b3"]])

export default __exports__